import { useEffect, useRef } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { syncPushTokenApi } from '../api/deviceRegistrationApi'
import { QUERY_KEY } from '../utils/constants'

// Syncs the push token for logged-in users on every app launch, on login, and whenever
// Firebase returns a different token. Guests stay on useDeviceRegistration.
export const usePushTokenSync = ({ enabled = true } = {}) => {
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated)
  // Redux only holds the token Firebase returned this session; the localStorage copy can be stale
  const fcmToken = useSelector((state) => state.auth?.fcmToken)
  const syncedTokenRef = useRef(null)

  const { mutate } = useMutation({
    mutationKey: [QUERY_KEY.SYNC_PUSH_TOKEN],
    mutationFn: syncPushTokenApi,
    retry: 2,
    onError: (error, pushToken) => {
      console.error('Push token sync failed:', error)
      if (syncedTokenRef.current === pushToken) {
        syncedTokenRef.current = null
      }
    }
  })

  useEffect(() => {
    if (!isAuthenticated) {
      syncedTokenRef.current = null
      return
    }

    if (!enabled || !fcmToken || fcmToken === 'FAILED') return
    if (!localStorage.getItem('deviceId')) return
    if (syncedTokenRef.current === fcmToken) return

    syncedTokenRef.current = fcmToken
    mutate(fcmToken)
  }, [isAuthenticated, fcmToken, enabled, mutate])
}
